    import React from 'react';
    import { Link } from 'react-router-dom';
    import { useTranslation } from 'react-i18next';
    import Navbar from '../../components/navbar/navbar';
    import UserNav from '../../components/navbar/user-nav';
    import FooterTop from '../../components/footer-top';
    import Footer from '../../components/footer';
    import GridPropertyOne from '../../components/grid-property-one';
    import HeroSearchFilter from '../../components/HeroSearchFilter';
    import Achievement from '../../components/achievement';
    import TeamOneReal from '../../components/team-one-real';
    import WhyAMPI from '../../components/WhyAMPI';
    import BeneficiosPreview from '../../components/BeneficiosPreview';
    import CTAAfiliacion from '../../components/CTAAfiliacion';
    import heroImg from '../../assets/img/side-city-1.png';
    import LatestProperties from '../../components/LatestProperties';
    import { useUser } from '../../context/UserContext';
    import back2 from '../../assets/img/back2.png';
    import SEO from '../../components/SEO';
    import { generateWebSiteSchema } from '../../utils/schema';


    export default function Index() {
    const { t } = useTranslation();
    const { user } = useUser();

    return (
        <>
        <SEO
          title="Portal Inmobiliario Riviera Nayarit"
          description="AMPI Riviera Nayarit: portal inmobiliario con propiedades en venta y renta, agencias certificadas y asesores profesionales en Bahía de Banderas, Nuevo Vallarta, Sayulita y Punta de Mita."
          path="/"
          keywords="inmobiliaria riviera nayarit, propiedades venta nayarit, bienes raíces bahía de banderas, casas nuevo vallarta, departamentos sayulita, AMPI nayarit, real estate riviera nayarit"
          schema={generateWebSiteSchema()}
        />
        {user ? (
          <UserNav 
            nombreUsuario={user.nombre} 
            nombreInmobiliaria={user.inmobiliaria_nombre} 
          />
        ) : (
          <Navbar transparent={true}/>
        )}

        <div className="light-bg hero-banner">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                        <p className="d-inline-flex sm-small text-light rounded-5 px-2 py-1 bg-dark align-items-center">
                            {t('home.newPlatformBadge')}
                            <span className="sm-small px-2 rounded-5 bg-primary text-light ms-2">{t('home.newLabel')}</span>
                        </p>
                        <h2 className='my-3 text-light'>{t('home.mainTitle')}</h2>
                        <p className="small" style={{ color: '#1b7a54' }}>{t('home.mainSubtitle')}</p>

                        {/* Aquí el componente nuevo */}
                        <HeroSearchFilter />
                       
                    </div>

                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                        <div>
                            <img src={heroImg} className="img-fluid" alt="AMPI Riviera Nayarit — Asociación Mexicana de Profesionales Inmobiliarios"  loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section style={{ backgroundImage: `url(${back2})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7 col-md-10 text-center">
                        <div className="sec-heading center mb-4">
                        <h2 style={{ color: '#2a856b' }}>
                            {t('home.statsTitle')}
                        </h2>
                            <p style={{ color: '#2a856b' }}>{t('home.statsSubtitle')}</p>
                        </div>
                    </div>
                </div>
                <Achievement/>
            </div>
        </section>

        {/* ¿Por qué AMPI? - Beneficios de ser miembro */}
        <WhyAMPI />

        <section style={{ backgroundColor: '#0a2f27' }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-7 col-md-10 text-center">
                        <div className="sec-heading center text-light">
                            <h2 style={{ color: 'white' }}>{t('home.latestPropertiesTitle')}</h2>
                            <p style={{ color: '#02de7f' }}>{t('home.latestPropertiesSubtitle')}</p>
                        </div>
                    </div>
                </div>
                <LatestProperties />
                <div className="text-center mt-5">
                    <Link to="/agents" className="btn btn-primary px-md-5 rounded ">
                        {t('home.exploreMoreProperties')}
                    </Link>
                </div>
            </div>
        </section>

        {/* Preview de Convenios y Beneficios */}
        <BeneficiosPreview />

        <section style={{ backgroundColor: '#dff0e6' }}>
            <div className="container">
                <div className="sec-heading center">
                    <h2 style={{ color: '#0f322b' }}>{t('home.advisorsTitle')}</h2>
                    <p style={{ color: '#298669' }}>{t('home.advisorsSubtitle')}</p>
                </div>
                <TeamOneReal/>
                <div className="text-center mt-5">
                    <Link to="/asociados" className="btn btn-primary px-lg-5 rounded">
                        {t('home.exploreMoreAdvisors')}
                    </Link>
                </div>
            </div>
        </section>

        {/* CTA para Afiliación */}
        <CTAAfiliacion />

        <FooterTop bg="theme-bg"/>
        <Footer/>
        </>
    )
    }
